import React, { useState } from "react";

import Heading from "./Heading";
import { SaveChangesPopup } from "./savePopup";
import Contact from "./contact";
import Teacher from "./Teacher";

const Home = () => {
  const [showPopUp, setShowPopUp] = useState(false);
  async function handleSave() {}
  function handleClose() {
    setShowPopUp(false);
  }

  return (
    <div className="bg-[#F1F5F9] bg-cover min-h-screen">
      <div className="flex flex-row font-['Roboto']">
        <div className="flex flex-col">
          <h1
            className=" lg:mt-[24px] lg:ml-[3rem]  2xl:mt-[48px] font-['Roboto'] font-semibold lg:text-[40px] 2xl:text-4xl text-[#1A2338]"
            style={{ lineHeight: "78px" }}
          >
            Home Page
          </h1>
          <p className="my-2 font-bold lg:text-[24px] 2xl:text-xl text-sm lg:ml-[3rem]  text-[#1A2338B2] ">
            Hero banner
          </p>
        </div>
      </div>
      <Heading />
      <Contact />
      <Teacher />
      <SaveChangesPopup
        onSave={handleSave}
        open={showPopUp}
        onClose={handleClose}
      />
    </div>
  );
};

export default Home;
